import React from "react";
import { FiSearch } from "react-icons/fi";

interface SearchInputProps {
    handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    placeholder?: string;
}

const SearchInputComponent: React.FC<SearchInputProps> = ({ handleSearch, className, placeholder = "Search" }) => {
    return (
        <div className={`w-full flex ${className}`}>
            <div className="relative w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-[23rem]">
                <FiSearch
                    className="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400"
                    size={16}
                />
                <input
                    type="text"
                    placeholder={placeholder}
                    onChange={handleSearch}
                    className="
            w-full
            pl-9 sm:pl-12 pr-4 sm:pr-5
            py-2 sm:py-3
            rounded-full
            text-xs sm:text-sm md:text-base
            text-gray-700
            placeholder:text-gray-400
            border border-gray-300
            focus:outline-none
            focus:ring-2 focus:ring-primary-red focus:border-transparent
            transition-all duration-200
            shadow-sm
          "
                />
            </div>
        </div>
    );
};

export default SearchInputComponent;
